import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'pdf/:token',
    loadComponent: () =>
      import('./features/verify/components/pdf-certificate/pdf-certificate.component').then(
        m => m.PdfCertificateComponent
      ),
  },
  {
    path: ':token',
    loadComponent: () =>
      import('./features/verify/components/verify-profile/verify-profile.component').then(
        m => m.VerifyProfileComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/verify/components/verify-profile/verify-profile.component').then(
        m => m.VerifyProfileComponent
      ),
  },
];
